import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from '@/api/ApiConst.js'

Vue.use(VueAxios, axios)

const backendApi = Vue.axios.create({
  baseURL: api,
  timeout: 1000,
  headers: {
    'Content-Type': 'application/json'
  }
})

var addAuth = (data) => {
  if (data === undefined || data === '') data = {}
  data['token'] = localStorage.getItem('token')
  data['email'] = localStorage.getItem('email')
  return JSON.stringify(data)
}

const ApiClient = {
  login: (usr, pswd) => backendApi.post(`/members/login`, {email: usr, password: pswd}),
  register: (usr, pswd, name) => backendApi.post(`/members/register`, {email: usr, password: pswd, name: name}),
  products: (name, type) => backendApi.post(`/site/products`, {productName: name, productType: type}),
  productDetail: (detailId) => backendApi.post(`/site/products/detail`, addAuth({detailId: detailId})),
  productTypes: () => backendApi.post(`/site/products/types`),
  news: (name) => backendApi.post(`/site/news`, {newsName: name}),
  newsDetail: (detailId) => backendApi.post(`/site/news/detail`, {detailId: detailId}),
  latestNews: () => backendApi.post(`/site/latestnews`),
  highlights: () => backendApi.post(`/site/highlights`),
  search: (text) => backendApi.post(`/site/search`, {searchText: text}),
  contact: (name, email, company, message) => backendApi.post(`/site/contact`, {name: name, company: company, email: email, text: message}),
  onError: (errorMsg) => {
    console.log(errorMsg)
  }
}

export default ApiClient



// WEBPACK FOOTER //
// ./src/api/ApiClient.js